import { render, staticRenderFns } from "./AddEtablissement.vue?vue&type=template&id=78d8cd50&"
import script from "./AddEtablissement.vue?vue&type=script&lang=js&"
export * from "./AddEtablissement.vue?vue&type=script&lang=js&"
import style0 from "./AddEtablissement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports